import React from "react";
import { Outlet } from "react-router-dom";
function Home() {
  return (
    <div className="home-wrap">
      <div
        style={{
          width: "100vw",
          height: "100vh",
        }}
        className="content"
      >
        <Outlet></Outlet>
      </div>
    </div>
  );
}

export default Home;
